import React, { useEffect, useState } from "react";
import { SnackbarProvider } from "notistack";
import { Button, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// routes
import Routers from "./routes";
// theme
import ThemeConfig from "./theme";
import GlobalStyles from "./theme/globalStyles";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/index.css";
import "./assets/css/style.css";
import ScrollToTop from "./components/ScrollToTop";
import { BaseOptionChartStyle } from "./components/charts/BaseOptionChart";
import { ContextPGIMode } from "./Hooks/PGIModeContext";
import { get_app_headers } from "./config/config";
import { Helmet } from "react-helmet";
import { ContentSettingState } from "./Hooks/ContentContext/ContentSettingState";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { get_site_setting } from "./DAL/Payment/Payment";

export default function App() {
  const notistackRef = React.createRef();
  const headers = get_app_headers();

  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };
  const [stripePublicKey, setStripePublicKey] = useState({});

  const stripePromise = loadStripe(
    "pk_test_51H2sBPIxjPbX33fQYlsCToNuBBTlFI12RzD4IPrr3YuEOYSoYaxQNmpbSNi39Pw28YvMHhz3Tfv7vMXmm3wWUXaf00eC2UhFlk"
  );

  console.log(stripePromise, "stripePromise");
  const getStripePublicKey = () => {
    // if (!localStorage.getItem("token")) {
    //   return loadStripe("");
    // }
    return new Promise(async (resolve, reject) => {
      const result = await get_site_setting();
      if (result.code === 200) {
        // Testing or live keys
        if (result.site_setting.stripe_mode === "sandBox") {
          console.log("calle");
          console.log(result.site_setting.sandBox_publish_key, "stripe keys");
          resolve(loadStripe(result.site_setting.sandBox_publish_key));
        } else {
          resolve(loadStripe(result.site_setting.live_publish_key));
        }
      } else {
        alert(result.message);
      }
    });
  };

  useEffect(() => {
    console.log(stripePublicKey, "stripePublicKey");
  }, [stripePublicKey]);
  useEffect(() => {
    getStripePublicKey();
  }, []);
  return (
    <ContextPGIMode>
      <ThemeConfig>
        <ScrollToTop />
        <GlobalStyles />
        <BaseOptionChartStyle />
        <SnackbarProvider
          ref={notistackRef}
          action={(key) => (
            <Button
              className="snackbar-cross-icon"
              onClick={onClickDismiss(key)}
            >
              <CloseIcon />
            </Button>
          )}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          TransitionComponent={Slide}
          maxSnack={3}
        >
          <Helmet>
            <title>{headers && headers.title}</title>
            <meta name="description" content={headers && headers.description} />
            <link
              rel="icon"
              type="image/x-icon"
              href={headers && headers.fav_icon}
            />
          </Helmet>
          <Elements stripe={getStripePublicKey()}>
            <ContentSettingState>
              <Routers />
            </ContentSettingState>
          </Elements>
        </SnackbarProvider>
      </ThemeConfig>
    </ContextPGIMode>
  );
}
